(function () {
  'use strict';

  function queue() { return window._ddCartQueue || {}; }

  function copyCartEventDetail(detail) {
    var out = {};
    if (!detail || typeof detail !== 'object') return out;
    for (var key in detail) {
      if (!Object.prototype.hasOwnProperty.call(detail, key)) continue;
      out[key] = detail[key];
    }
    return out;
  }

  function extractCartFromEventDetail(detail) {
    if (!detail || typeof detail !== 'object') return null;
    var q = queue();
    var hasShape = q.hasAuthoritativeCartShape || function () { return false; };
    if (hasShape(detail.cartData)) return detail.cartData;
    if (hasShape(detail.cart)) return detail.cart;
    if (hasShape(detail)) return detail;
    return null;
  }

  function normalizeCartUpdatedDetail(detail, fallbackSource) {
    var normalized = copyCartEventDetail(detail);
    if (!normalized.source && fallbackSource) normalized.source = fallbackSource;
    if (!normalized.source) normalized.source = 'dd-cart-helpers';
    var authoritative = extractCartFromEventDetail(normalized);
    if (authoritative) {
      normalized.cartData = authoritative;
      normalized.cart = authoritative;
    }
    return normalized;
  }

  function publishCartUpdate(data, source) {
    var resolvedSource = source || 'dd-cart-helpers';
    var payload = normalizeCartUpdatedDetail({ source: resolvedSource, cartData: data, cart: data }, resolvedSource);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, payload);
    }
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: payload })); } catch (e) {}
  }

  function formatMoney(cents) {
    var fmt = (window.shopMoneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var amount = (cents / 100).toFixed(2);
    var amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = fmt
      .replace(/\{\{\s*amount\s*\}\}/, amountWithCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString());
    // Match Liquid's `money_without_trailing_zeros` so cart notifications
    // stay consistent with the rest of the cart UI.
    return out.replace(/([.,])00(?!\d)/, '');
  }

  function formatMoneyWithCurrency(cents) {
    var fmt = (window.shopMoneyWithCurrencyFormat || window.shopMoneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var amount = (cents / 100).toFixed(2);
    var amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = fmt
      .replace(/\{\{\s*amount\s*\}\}/, amountWithCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString());
    return out.replace(/([.,])00(?!\d)/, '');
  }

  function isProtectionLine(item) {
    if (!item) return false;
    if (Number(item.product_id || 0) === 10266015924541) return true;
    var props = item.properties && typeof item.properties === 'object' ? item.properties : null;
    if (props && (props._dd_shipping_protection || props.dd_shipping_protection)) return true;
    var h = (item.handle || '').toLowerCase();
    var v = (item.vendor || '').toLowerCase();
    var t = (item.title || '').toLowerCase();
    return (
      h === 'dd-shipping-protection' ||
      v.indexOf('insureshield') !== -1 ||
      v.indexOf('insure shield') !== -1 ||
      t.indexOf('shipping protection') !== -1 ||
      t.indexOf('shipping insurance') !== -1
    );
  }

  function cartDisplayCount(cart) {
    if (!cart || !cart.items) return cart ? cart.item_count : 0;
    var count = 0;
    var items = cart.items;
    for (var i = 0; i < items.length; i++) {
      if (!isProtectionLine(items[i])) count += items[i].quantity;
    }
    return count;
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function reserveCheckoutNav() { return Promise.resolve(); }

  function estimatedCustomShipDate() {
    var d = new Date();
    d.setDate(d.getDate() + 56);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  var _cartAccordionCloseTimer = null;
  /* Grace before auto-closing the discount/note accordion after a
     successful action. Must be ≥ the visible toast duration
     (`cart-toast.js` defaults to 4000ms for both the inline cart
     toast and the inline `.dd-discount__feedback` message). The
     other half of this contract lives in `assets/cart-paint.js`
     `captureCartPageFooterEphemera` — the cart-page footer goes
     through a wholesale `innerHTML` swap on every cart mutation,
     and without that capture-restore the swap would close the
     accordion immediately (well before this timer fires) by
     replacing the live DOM with fresh SSR. */
  var CART_ACCORDION_CLOSE_GRACE_MS = 5000;

  function resolveCartAccordionRoot(scopeElement) {
    if (!scopeElement || !scopeElement.closest) return null;
    return scopeElement.closest('cart-drawer') || scopeElement.closest('#main-cart-footer');
  }

  function closeCartAccordionsInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    var accs = root.querySelectorAll('[data-dd-discount-accordion], [data-dd-note-accordion]');
    for (var i = 0; i < accs.length; i++) {
      var acc = accs[i];
      acc.classList.remove('is--open');
      var tgl = acc.querySelector('[data-dd-accordion-toggle]');
      if (tgl) tgl.setAttribute('aria-expanded', 'false');
    }
  }

  function scheduleCloseCartAccordions(scopeElement) {
    var root = resolveCartAccordionRoot(scopeElement);
    if (!root) return;
    clearTimeout(_cartAccordionCloseTimer);
    _cartAccordionCloseTimer = setTimeout(function () {
      _cartAccordionCloseTimer = null;
      closeCartAccordionsInRoot(root);
    }, CART_ACCORDION_CLOSE_GRACE_MS);
  }

  function hydrateCustomDeliveryDates() {
    var els = document.querySelectorAll('[data-dd-custom-delivery]:not([data-dd-hydrated])');
    if (!els.length) return;
    var date = estimatedCustomShipDate();
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = 'Delivery by ' + date;
      els[i].setAttribute('data-dd-hydrated', '1');
    }
  }
  hydrateCustomDeliveryDates();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(hydrateCustomDeliveryDates).observe(document.body, { childList: true, subtree: true });
  }

  window._ddCartNotify = {
    publishCartUpdate: publishCartUpdate,
    extractCartFromEventDetail: extractCartFromEventDetail,
    normalizeCartUpdatedDetail: normalizeCartUpdatedDetail,
    formatMoney: formatMoney,
    formatMoneyWithCurrency: formatMoneyWithCurrency,
    cartDisplayCount: cartDisplayCount,
    isProtectionLine: isProtectionLine,
    escHtml: escHtml,
    escAttr: escAttr,
    reserveCheckoutNav: reserveCheckoutNav,
    estimatedCustomShipDate: estimatedCustomShipDate,
    scheduleCloseCartAccordions: scheduleCloseCartAccordions
  };
})();
